import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', () => {
  const list = document.querySelector('.sortable-poses-list');

  if (!list) return;
  if (list.length === 0) return;

  Sortable.create(list, {
    handle: '.handle',
    onEnd: () => {
      const positionInputs = document.querySelectorAll('.position-input');

      positionInputs.forEach((input, i) => {
        input.value = i + 1;
      });
    },
  });
});
